import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotification,
  markNotificationAsRead,
} from "../../actions/commonActions";
import moment from "moment";
import { setPageTitle } from "../../utils/helper";

const NOTIFICATIONS_DATE_FORMAT = "YYYY-MM-DD hh:mm A";

const Notification = () => {
  const dispatch = useDispatch();
  const { driverNotifications } = useSelector((redux) => redux.common);

  const [notificationClicked, setNotificationClicked] = useState(false);
  const [driverId, setDriverId] = useState("");

  useEffect(() => {
    const driver_id = localStorage.getItem("driver_id");
    setDriverId(driver_id);
    getNotification(dispatch, driver_id);
    setPageTitle("Notifications");
  }, []);

  useEffect(() => {
    if (notificationClicked) {
      getNotification(dispatch, driverId);
      setNotificationClicked(false);
    }
  }, [notificationClicked]);

  const unReadNotificationClicked = (notificationId, e) => {
    markNotificationAsRead(dispatch, notificationId);
    setNotificationClicked(true);
  };

  // console.log("Notification Check:", { driverNotifications })

  return (
    <div className="notifications-page">
      <div>
        <div className="container-sm notifications-body">
          {driverNotifications.sort((a, b) => new Date(b.delivery_date_time) - new Date(a.delivery_date_time)).map((notification, index) => {
            if (notification.read_date_time) {
              return (
                <div
                  key={index}
                  className="alert alert-dark"
                  role="alert"
                  name="hello"
                >
                  <p className="notification-date">
                    {moment(notification.delivery_date_time).format(
                      NOTIFICATIONS_DATE_FORMAT
                    )}
                  </p>
                  {notification.notification_text}
                </div>
              );
            } else {
              return (
                <div
                  key={index}
                  className="alert alert-notification alert-dismissible fade show"
                  role="alert"
                  name="hello"
                >
                  <div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                      name="dasd"
                      onClick={(e) =>
                        unReadNotificationClicked(
                          notification.notification_destination_delivery_id,
                          e
                        )
                      }
                    >
                      <span className="fa fa-check" aria-hidden="true"></span>
                    </button>
                    <p className="notification-date">
                      {moment(notification.delivery_date_time).format(
                        NOTIFICATIONS_DATE_FORMAT
                      )}
                    </p>
                    {notification.notification_text}
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default Notification;
